// src/components/AboutUs/AboutUs.jsx
import React from "react";
import { Link } from "react-router-dom";
import BenefitsSection from "./BenefitsSection";
import mashood from "../../assets/images/Mashood.jpg";
import sabith from "../../assets/images/sabith.jpg";

export default function AboutUs() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 px-4 md:px-8 mt-12">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <h1
          className="text-3xl md:text-4xl text-[#333333] text-center mb-8 relative"
        >
          MASHO PERFUMES
          <span className="block w-24 h-1 bg-[#D4AF37] mx-auto mt-2"></span>
        </h1>

        {/* Our Story Section */}
        <section className="mb-12">
          <h2
            className="text-2xl text-[#333333] text-center mb-6"
          >
            Our Story
          </h2>
          <p className="text-gray-600 text-center text-sm md:text-base leading-relaxed max-w-3xl mx-auto">
            Since 2024 from a single conversation that ignited a lifelong passion. Mashood, our founder, transformed that spark into a mission — to bottle emotion, memory, and identity. Driven by heart, not hype, every scent we create whispers a story of purpose and presence. Rooted in tradition, alive with soul, MASHO blends timeless elegance with modern voice. This isn’t just perfume — it’s the power of one idea, captured forever.          </p>
        </section>

        {/* Meet the Founders Section */}
        <section className="mb-12">
          <h2
            className="text-2xl text-[#333333] text-center mb-8"
          >
            Meet the Founders
          </h2>
          <div className="flex flex-col md:flex-row justify-center gap-8 md:gap-12">
            {/* Founder */}
            <div className="flex flex-col items-center">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-full border-4 border-[#D4AF37] overflow-hidden mb-4">
                {/* Placeholder for Founder Photo */}
                <img
                  src= {mashood}
                  alt="Founder of MASHO Perfumes"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3
                className="text-lg text-[#333333] font-semibold"
              >
                Mashood
              </h3>
              <p className="text-[#D4AF37] text-sm mb-2">Founder</p>
              <p className="text-gray-600 text-center text-sm max-w-xs">
                Mashood, the creator of MASHO Perfumes, is a self-made perfumer with a big dream: to capture feelings in bottles. He believes scents should tell stories, not just smell nice. With passion as his guide, he turns simple ingredients into special fragrances that mean something. Every perfume is his way of making emotions last forever.              </p>
            </div>

            {/* Co-Founder */}
            <div className="flex flex-col items-center">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-full border-4 border-[#D4AF37] overflow-hidden mb-4">
                {/* Placeholder for Co-Founder Photo */}
                <img
                  src= {sabith}
                  alt="Co-Founder of MASHO Perfumes"
                  className="w-full h-full object-cover"
                />
              </div>
              <h3
                className="text-lg text-[#333333] font-semibold"              >
                Sabith
              </h3>
              <p className="text-[#D4AF37] text-sm mb-2">Co-Founder</p>
              <p className="text-gray-600 text-center text-sm max-w-xs">
                Sabith, the co-founder of MASHO Perfumes, is the creative force who turns visions into reality. With a marketer’s mind and an artist’s soul, he shapes the stories behind every scent. His knack for spotting beauty in raw ideas helps transform simple fragrances into unforgettable experiences. Where Mashood crafts emotions in bottles, Sabith makes sure the world feels them too.              </p>
            </div>
          </div>
        </section>

        <section className="pt-12 py-12 px-4 md:px-8 max-w-7xl mx-auto bg-gradient-to-b from-gray-50 to-white">
          {/* Section Header */}
          <div className="text-center mb-8">
            <h1
              className=" text-2xl md:text-4xl text-[#333333] mb-2 tracking-wide animate-pulse"
              
            >
              Experience the luxury
            </h1>
            <p className="text-sm md:text-base text-gray-500 max-w-md mx-auto">
              Experience the luxury and quality that sets MASHO Perfumes apart.
            </p>
            <div className="mt-4 h-1 w-20 bg-[#D4AF37] mx-auto rounded-full"></div>
          </div>
          {/* Benefits Section */}
          <BenefitsSection />
        </section>

        {/* Call to Action */}
        <div className="text-center">
          <Link
            to="/shop"
            className="inline-block bg-[#D4AF37] text-black px-6 py-3 rounded-sm text-sm font-medium hover:bg-[#C19B2E] transition-all duration-200"
          >
            Explore Our Collection
          </Link>
        </div>
      </div>
    </div>
  );
}